import API from "../api";

export const getBillingSettings = () => API.get("/admin/billing-settings");

export const saveBillingSettings = (payload) => API.put("/admin/billing-settings", payload);

export const getEnrollmentPaymentPreview = (role, params) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "ADMIN"
      ? "/admin/enrollments/payment-preview"
      : normalizedRole === "MANAGER"
        ? "/manager/enrollments/payment-preview"
        : "/coach/enrollments/payment-preview";
  return API.get(base, { params });
};
